<template>
    <div class="d-flex align-center">
        <span class="font-weight-bold pb-1 mr-5">Bruk som standard betalingsmåte</span>
        <v-switch
            color="primary"
            v-model="model"
            readonly
            @click="$emit('update', 1)"
        ></v-switch>
    </div>
</template>

<script>
export default {
    props: {
        model: {
            required: false,
            default: 100,
        },
    },
    
}
</script>